import React from "react";
import { Table, Checkbox, Chip } from "@mantine/core";
import { ReactComponent as CheckIcon } from "@/assets/icons/check.svg";
import { ReactComponent as MinusIcon } from "@/assets/icons/minus.svg";
import { findActiveSubscription } from "@/helpers/issuesAndSubscriptions";
import { UserWithSubscriptions } from "@/api/types";
import dayjs from "dayjs";
import clsx from "clsx";

interface UserTableRowProps {
  user: UserWithSubscriptions;
  selectedRows: number[];
  onSelectRow: (id: number) => void;
  onClickRow: (id: number) => void;
}

const UserTableRow: React.FC<UserTableRowProps> = ({
  user,
  selectedRows,
  onSelectRow,
  onClickRow,
}) => {
  const isSelected = selectedRows.includes(user.id);

  return (
    <Table.Tr
      key={user.id}
      className={clsx(
        "cursor-pointer hover:bg-[#f9f9f9] !rounded-e-xl",
        isSelected ? "!bg-[#f5faff]" : undefined
      )}
      onClick={(event) => {
        if ((event.target as HTMLElement).tagName === "INPUT") return;
        event.preventDefault();
        onClickRow(user.id);
      }}
    >
      <Table.Td className="!p-3.5">
        <Checkbox
          aria-label="Select row"
          color="#004a99"
          classNames={{
            input: "!cursor-pointer",
          }}
          checked={isSelected}
          onChange={() => onSelectRow(user.id)}
        />
      </Table.Td>
      <Table.Td>{user.firstName + " " + user.lastName}</Table.Td>
      <Table.Td>{user.email}</Table.Td>
      <Table.Td className="text-center">
        <Chip
          checked={true}
          color={
            !!findActiveSubscription(user.userSubscriptions)
              ? "#2c973f"
              : "#515151"
          }
          icon={
            !!findActiveSubscription(user.userSubscriptions) ? (
              <CheckIcon />
            ) : (
              <MinusIcon />
            )
          }
          variant="light"
          className="!cursor-default font-bold py-1"
          classNames={{ label: "!py-[1.15rem]" }}
        >
          {!!findActiveSubscription(user.userSubscriptions)
            ? "Aktivna"
            : "Neaktivna"}
        </Chip>
      </Table.Td>
      <Table.Td>
        {(!!findActiveSubscription(user.userSubscriptions) &&
          dayjs(
            findActiveSubscription(user.userSubscriptions)?.startDate
          ).format("DD.MM.YYYY.")) ||
          "-"}
      </Table.Td>
      <Table.Td>
        {(!!findActiveSubscription(user.userSubscriptions) &&
          dayjs(findActiveSubscription(user.userSubscriptions)?.endDate).format(
            "DD.MM.YYYY."
          )) ||
          "-"}
      </Table.Td>
    </Table.Tr>
  );
};

export default UserTableRow;
